import React from "react";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  return (
    <div
      className="flex items-center justify-center p-3 min-h-[550px] bg-gradient-to-r from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90%"
      style={{
        background: `url('../assets/signup-bg.jpg') no-repeat top right`,
        height: "100vh",
        backgroundSize: "cover",
      }}
    >
      <div className="w-full max-w-md bg-white p-5 rounded-lg ms-0 md:ms-48 shadow-sm border border-gray-300">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Forgot Password?
        </h2>
        <p className="text-sm text-gray-600 text-center mb-6">
          Enter your email address and we'll send you a link to reset your
          password.
        </p>
        <form className="space-y-5">
          <input
            type="email"
            placeholder="Enter your email"
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            className="w-full bg-[#82b016] text-white py-2 rounded-md hover:bg-gray-700 transition"
          >
            Send Reset Link
          </button>
          <p className="text-sm text-center text-gray-600 mt-4">
            Remember your password?{" "}
            <Link to="/SignIn" className="text-[#82b016] hover:underline">
              Sign In
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
